<template>
  <OrEmptyStateV3
    :image-src="rocketPng"
    :heading="$t('queuesTable.empty.mainText')"
    :text="$t('queuesTable.empty.secondaryText')"
    size="l"
    data-test="empty-state"
  />
</template>
<script lang="ts">
import {
  OrEmptyStateV3,
} from '@onereach/ui-components';
import { defineComponent } from 'vue';

import rocketPng from '@/assets/rocket.png';

export default defineComponent({
  name: 'QueuesEmpty',
  components: {
    OrEmptyStateV3,
  },
  setup() {
    return {
      rocketPng,
    };
  },
});
</script>
